import { makeStyles } from "tss-react/mui";
import { MiButton, MiIcon, MiInputTextbox } from "@miplatform/components";
import { BUTTON_COLORS, BUTTON_VARIANTS } from "@miplatform/constants";
import { IDocumentListItemResponse } from "@miplatform/types";
import { mdiFileCheck, mdiTrashCanOutline, mdiTrayArrowUp } from "@mdi/js";
import { DOC_CATEGORY } from "../../../../constants";

export function InputFile({
  doc,
  handleRemoveFile = () => null,
  handleOpenUploadModal,
  label,
  required,
}: InputFileProps) {
  const { classes, theme } = useStyles();

  if (!doc) {
    return (
      <MiButton
        color={BUTTON_COLORS.BLACK}
        startIcon={{
          path: mdiTrayArrowUp,
          iconColor: theme.palette.grey.medium,
        }}
        onClick={handleOpenUploadModal}
        variant={BUTTON_VARIANTS.OUTLINED}
        className={classes.uploadButton}
      >
        {label}
        {required && <span style={{ color: theme.palette.red.main }}> *</span>}
      </MiButton>
    );
  }

  return (
    <MiInputTextbox
      disabled
      value={doc.metadata?.title || doc.title}
      label={doc.category}
      required={
        doc.category === DOC_CATEGORY.PLAN || doc.category === DOC_CATEGORY.SPEC
      }
      className={classes.inputFileTextBox}
      textfieldProps={{
        startAdornment: (
          <MiIcon
            path={mdiFileCheck}
            color={theme.palette.green.main}
            className={classes.startIcon}
          />
        ),
        endAdornment: (
          <MiButton
            color={BUTTON_COLORS.GREY}
            variant={BUTTON_VARIANTS.TEXT}
            onClick={() => handleRemoveFile(doc)}
            startIcon={{ path: mdiTrashCanOutline }}
          />
        ),
      }}
    />
  );
}

const useStyles = makeStyles()((theme) => ({
  uploadButton: {
    border: `1px dashed ${theme.palette.grey.darkAccent}`,
    width: "100%",
    justifyContent: "flex-start",
    gap: theme.spacing(1),
    height: 40,
    padding: theme.spacing(0, 4),
  },
  startIcon: {
    marginRight: theme.spacing(1),
  },
  inputFileTextBox: {
    "& .MuiOutlinedInput-root": {
      paddingRight: 0,
    },
  },
}));

interface InputFileProps {
  doc?: IDocumentListItemResponse;
  handleRemoveFile?: (doc: IDocumentListItemResponse) => void;
  handleOpenUploadModal?: () => void;
  label?: string;
  required?: boolean;
}
